enum DrawerItems {
  TRADE_IN = "trade_in",
  TEST_DRIVE = "test_drive",
  CALL = "call",
  MESSAGE = "message",
  CONTACT = "contact",
  MINIMIZE = "minimize",
  OPEN = "open",
}

export default DrawerItems
